<template>
  <div class="education">
    <h2>Education</h2>
    <div class="grid-container">
      <div
        class="grid-item"
        v-for="item in education"
        :key="item.heading"
        :data="item"
      >
        <a v-bind:href="item.link" target="_blank"
          ><h3>{{ item.heading }}</h3></a
        >
        <p
          v-for="program in item.description"
          :key="program"
          class="description"
        >
          {{ program }}
        </p>
        <p class="edu-point">
          <i class="fa fa-calendar fa-fw mini-icon" aria-hidden="true"></i
          ><span class="date">{{ item.dates }}</span>
        </p>
        <p class="edu-point">
          <i class="fa fa-map-marker fa-fw mini-icon" aria-hidden="true"></i
          ><span class="date">{{ item.place }}</span>
        </p>
        <p class="edu-point" v-if="item.grade">
          <i class="fa fa-graduation-cap fa-fw mini-icon" aria-hidden="true"></i
          ><span class="date">{{ item.grade }}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { education } from "@/data/about.js";

export default {
  name: "Education",
  data() {
    return {
      education
    };
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/_media_sizes.scss";
@import "@/assets/_colours.scss";
@import "@/assets/_font.scss";
@import "./style.scss";

.education {
  .grid-container {
    display: grid;
    grid-template-columns: 1fr;

    .grid-item {
      flex-grow: 1;
      margin: 20px 40px 20px 0;
      a {
        text-decoration: none;

        &:hover {
          text-decoration: underline;
          text-decoration-color: $accent-blue;
        }
      }

      .description {
        font-family: "Roboto", sans-serif;
      }

      .edu-point {
        font-size: $font-XXS;
        margin: 10px 0;
        font-family: "PT Mono", monospace;
        color: black;

        .mini-icon {
          color: $accent-darker-blue !important;
        }
      }
    }
  }
}

@media only screen and (min-width: $tablet-potrait) {
  .education {
    .grid-container {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-gap: 50px;

      .grid-item {
        margin: 0;
      }
    }
  }
}
</style>
